import React from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { clientBreadcrumbsHistory } from './functions';

const ClientBreadcrumbs = () => {
  const location = useLocation();
  const match = useRouteMatch();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="client-breadcrumbs"
      history={clientBreadcrumbsHistory(t, location, match)}
    />
  );
};

export default ClientBreadcrumbs;
